import { render, staticRenderFns } from "./vipBox.vue?vue&type=template&id=bee5ded4&scoped=true"
import script from "./vipBox.vue?vue&type=script&lang=js"
export * from "./vipBox.vue?vue&type=script&lang=js"
import style0 from "./vipBox.vue?vue&type=style&index=0&id=bee5ded4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5ded4",
  null
  
)

export default component.exports